export default {
    navigationBarTitleText: '申请注销账号'
  };
  